// extracted by mini-css-extract-plugin
export var button = "styles-module--button--db91a";
export var closed = "styles-module--closed--3e9a9";
export var disclaimer = "styles-module--disclaimer--c7cdf";
export var header = "styles-module--header--26c10";
export var icon = "styles-module--icon--7868d";
export var open = "styles-module--open--799c2";
export var subtitle = "styles-module--subtitle--f8151";
export var title = "styles-module--title--150c3";